module.exports = __webpack_public_path__ + "img/weibo.38c81550.png";